module.exports = __webpack_public_path__ + "static/media/hyperledger_logo.b9684e23.png";